import { render } from "./TrackerLogRatingButton.vue?vue&type=template&id=58afa3a7&scoped=true"
import script from "./TrackerLogRatingButton.vue?vue&type=script&lang=js"
export * from "./TrackerLogRatingButton.vue?vue&type=script&lang=js"

import "./TrackerLogRatingButton.vue?vue&type=style&index=0&id=58afa3a7&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58afa3a7"]])

export default __exports__